export default{
    common: {
        unit: 'USDT',
        day: '日',
        week: '週間',
        save: '保存',
        submit: '送信',
        confirmtitle: '操作を確認',
        confirm: '確認',
        reset: 'リセット',
        refresh: '更新',
        copy: 'コピー',
        copysuccessful: 'コピー成功',
        modify: '修正',
        binding: '紐付け',
        finished: '完了',
        canceled: 'キャンセル済み',
        cancel: 'キャンセル',
        all: '全て',
        back: '戻る',
        loading: '読み込み中...',
        nomore: '全ての記録',
        errortxt: '読み込み失敗',
        loosing: '更新するには離してください...',
        pulling: '下にスワイプして更新...',
        nodata: '記録がありません',
        buy: '購入',
        buyup: '買い上がり',
        buydown: '買い下がり',
        sell: '売却',
        forserver: 'カスタマーサービスにお問い合わせください',
        total: '合計',
        status1: '審査中',
        status2: '完了',
        status3: '却下',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: '電信送金'
    },
    footer: {
        home: 'ホーム',
        market: 'マーケット',
        exchange: '取引所',
        options: 'オプション',
        assets: '資産',
        change: '振替',
        recharge: '入金',
        withdrawal: '出金'
    },
    home: {
        menu1: 'オプション取引',
        menu1desc: 'BTC/USDTなどに対応',
        menu2: 'クイック入金',
        menu3: '出金',
        menu4: 'オンラインサポート',
        menu5: '即時両替',
        menu6: 'ローン',
        menu7: 'ステーキングマイニング',
        menu8: '担保',
        menu9: 'アカウント送金',
        ranktitle: '上昇率ランキング',
        name: '名称',
        price: '最新価格',
        risefall: '変動率'
    },
    register: {
        register: '登録',
        login: 'ログイン',
        email: 'メールアドレス',
        phone: '電話番号',
        accountplaceholder: 'アカウントを入力',
        emailplaceholder: 'メールアドレスを入力',
        phoneplaceholder: '電話番号を入力',
        pwdplaceholder: 'パスワードを入力',
        pwdplaceholder1: 'パスワードは6-20文字で入力してください',
        agepwdplaceholder: 'パスワードを再入力',
        agepwdplaceholder1: 'パスワードが一致しません',
        invitecodeplaceholder: '招待コードを入力',
        remember: 'パスワードを記憶',
        fotget: 'パスワードをお忘れの方'
    },
    market: {
        title: 'マーケット',
        all: '全て'
    },
    member: {
        reputation: '信用スコア',
        identity_authentication: '本人確認',
        under_review: '審査中',
        certified: '認証済み',
        awaiting_certification: '認証待ち',
        binding_withdrawal_address: '出金アドレスの登録',
        currently_selected_currency: '現在の通貨',
        withdrawal_address: '出金アドレス',
        sharing_link: '紹介リンク',
        my_promotion_code: '紹介コード',
        promotion_code: 'プロモーションコード',
        system_message: 'システムメッセージ',
        night_mode: 'ナイトモード',
        security_center: 'セキュリティセンター',
        seted: '設定済み',
        noset: '未設定',
        login_password: 'ログインパスワード',
        transaction_password: '取引パスワード',
        app_download: 'アプリダウンロード',
        log_out: 'ログアウト',
        aboutus: 'ウェブサイトの紹介'
    },
    identity: {
        title: '本人確認',
        name: '氏名',
        nameplaceholder: '本名を入力',
        uploader: '身分証明書の写真をアップロード',
        tip1: '身分証明書の表面をアップロード',
        tip2: '身分証明書の裏面をアップロード'
    },
    address: {
        title: '出金アドレスの登録',
        bType: '現在の通貨',
        address: '出金アドレス',
        addressplaceholder: '出金アドレスを入力'
    },
    security: {
        title: 'セキュリティセンター',
        modifypwd: 'ログインパスワード',
        resetlegalpwd: '取引パスワード',
        loginpwd: '新しいログインパスワード',
        pwdage: 'パスワード確認',
        loginpwdplaceholder: '現在のログインパスワードを入力',
        loginnewpwdplaceholder: '新しいログインパスワードを入力',
        moneypwd: '取引パスワードを入力',
        pwdageplaceholder: 'パスワードを再入力'
    },
    trade: {
        title: '取引所取引',
        price: '価格',
        num: '数量',
        entrust: '現在の注文',
        clinch: '約定履歴',
        used: '利用可能',
        buyed: '購入可能',
        amount: '取引額',
        limitprice: '指値',
        marketprice: '成行',
        forprice: '現在の最良価格で取引',
        errorMoney: '残高不足',
        priceerror: '注文価格を入力',
        numerror: '注文数量を入力',
        moneyerror: '注文金額を入力'
    },
    assets: {
        allconvert: '総資産（換算）',
        usenum: '利用可能',
        freeze: '凍結中',
        convert: '換算',
        tab1: '資産',
        tab11: '総資産（換算）',
        tab12: 'オプション（換算）',
        tab13: '資金（換算）',
        tab14: '量的（換算）',
        tab2: 'オプション',
        tab21: 'オプションアカウント',
        tab3: '資金',
        tab31: '資金アカウント',
        tab4: '量的取引',
        tab41: '量的取引アカウント',
        tbhead1: '財務記録',
        tbhead2: '出金記録',
        tbhead3: '入金記録',
        tbhead4: '振替記録',
        rcdnum: '数量',
        rcd: '記録',
        rcdtime: '時間',
        rcdstatus: 'ステータス',
        rcddesc: '備考',
        rcdaddress: '入金アドレス'
    },
    change: {
        title: '振替',
        from: '{name}から',
        to: '{name}へ',
        frmtitle: '振替数量',
        inputplaceholder: '振替数量を入力',
        btntxt: '振替'
    },
    recharge: {
        title: '入金',
        bType: '現在の通貨',
        address: '入金アドレス',
        token: '支払い証明',
        tokenplaceholder: '支払い証明をアップロード',
        num: '入金数量',
        numplaceholder: '数量を入力',
        btn: '審査に提出',
        bankname: '銀行名',
        bankno: '銀行番号',
        accountname: '口座名義',
        bankaddress: '銀行住所',
        bankcode: '銀行送金コード',
        companyaddress: '会社住所'
    },
    withdrawal: {
        title: '出金',
        frmtitle1: '数量',
        frmplaceholder1: '出金数量は {min} - {max} の間で入力',
        frmtitle2: '取引パスワード',
        frmplaceholder2: '取引パスワードを入力',
        getnum: '受取数量',
        fee: '手数料',
        btn: '出金'
    },
    exchangeb: {
        title: '両替',
        account: 'アカウント',
        btn: '両替',
        numerror: '両替数量を入力'
    },
    option: {
        title: 'オプション',
        typetitle: '秒数取引',
        listtitle: 'ポジション',
        kline: 'チャート',
        high: '高値',
        low: '安値',
        nums: '24時間取引量',
        time: '時間',
        transaction: '取引モード',
        quantity: '取引数量',
        quantityerror: '取引数量を入力',
        times: '取引時間',
        times1: '決済時間',
        account: 'アカウント残高',
        buyup: '買い上がり',
        buydown: '買い下がり',
        tab1: 'ポジション一覧',
        tab2: '注文履歴',
        num: '数量',
        price1: '購入価格',
        price2: '決済価格',
        profitandloss: '予想損益',
        profitandloss1: '損益',
        countdown: 'カウントダウン',
        waitfinish: '決済待ち',
        finishing: '決済中...',
        finished: '決済済み',
        order_price: '現在価格',
        order_cycle: '期間',
        order_type: 'タイプ',
        order_money: '金額',
        order_time: 'オープン',
        order_get: '利益',
        order_btn: '取引を続ける'
    },
    tradelst: {
        title: '注文履歴',
        tab1: '注文中',
        tab2: '完了',
        tab3: 'キャンセル済み',
        usdtnum: ''
    },
    loans: {
        title: 'ローン',
        order_tab: 'ローン注文',
        pro_tab: 'ローン商品',
        Institution: '貸付機関',
        Amount: '金額',
        DailyInterest: '日利率',
        RepaymentPeriod: '返済期間',
        Application: 'ローン申請',
        orderno: '注文番号',
        AllInterest: '総利息',
        RepaymentDate: '返済日',
        RepaymentMethod: '返済方法',
        Onetime: '一括',
        Expected_loan_amount: '希望借入額',
        Expected_loan_amounterror: '借入額は {min} - {max} の間で入力',
        imgplaceholdr: '信用貸付（画像が明確に見えることを確認）',
        icon1: '身分証明書表面をアップロード',
        icon2: '身分証明書裏面をアップロード',
        icon3: '本人確認写真をアップロード',
        status1: '申請中',
        status2: '承認済み',
        status3: '却下'
    },
    lockming: {
        title: 'ステーキングマイニング',
        order_tab: 'マイニング注文',
        pro_tab: 'マイニングマーケット',
        locknum: '最小ステーキング数量',
        getforday: '収益率/日数',
        days: '日数',
        estimation: '予想収益',
        real: '獲得済み',
        balance: 'ウォレット残高',
        nums: 'ステーキング数量',
        tolockming: 'ステーキング',
        stime: '開始時間',
        etime: '終了時間'
    },
    transfer: {
        title: 'アカウント送金',
        searchtxt: '受取人アカウントを入力',
        ReceivingAccount: '受取人アカウント情報',
        toaccount: 'アカウント',
        confirmtxt: '受取人アカウントを確認してください',
        confirmedtxt: '受取人アカウント確認済み',
        numtxt: '送金数量',
        numerror: '送金数量を入力',
        fee: '内部送金手数料無料',
        ArrivalTime: '到着時間',
        Immediately: '即時',
        realnum: '実際の到着数量',
        btn: '送金確認',
        transfering: '送金中',
        orderNo: '注文番号',
        stime: '送金時間',
        etime: '到着時間',
        receiving: '受取人アカウント',
        type: '通貨',
        num: '送金数量',
        arrivalnum: '受取数量'
    },
    staking: {
        title: 'ステーキング',
        record: '記録',
        getforyear: '予想年間収益率',
        time: '投資期間',
        snum: '最小投資額',
        snumerror: '投資額を入力',
        snumerror1: '最小投資額は {num} 以上',
        join: '今すぐ参加',
        opentime: 'オープン時間',
        money: '投資額',
        days: '期間',
        recordget: '年間収益率',
        gets: '収益',
        stime: '開始日',
        etiem: '終了日',
        redeemStaking: '解約',
        status0: 'ステーキング中',
        status1: '注文終了',
        status2: '注文解約済み'
    },
    bank:{
        title: '銀行カード紐付け',  // 金融庁決済サービス表示基準
        bankName: '銀行名',  // 日本銀行金融機関コード表記
        bankNameError: '銀行名を入力してください',  // 全銀協入力規則
        usrName: 'カード名義人',  // 犯罪収益移転防止法 本人確認義務
        usrNameError: '名義人名を入力してください',  // KYC要項
        cardCode: 'カード番号',  // JIS X 0302 クレジットカード番号規格
        cardCodeError: 'カード番号を入力してください',  // PCI DSS準拠
        towallet: '仮想通貨ウォレットへ出金',  // 資金決済法第63条の2
        tobank: '銀行口座へ出金',  // 振込決済規約
        sendcode: '認証コード送信',  // 個人情報保護法(PPA)準拠
        sended: '{num}秒後に再送信',  // JIS X 0301 時間表記
        verify_code: 'メール認証コードを入力'  // 特定電子メール法
      },
      other:{
            welcome: 'こんにちは、{name}へようこそ',
    homeaboutustitle: 'グローバルリーディングなオールインインワンンデジタル資産取引プラットフォーム',
    homeaboutustitle1: 'セキュリティ保証',
    homeaboutusdesc1: '複数のトップクラスセキュリティ機関と協力し、ユーザーの取引を安全かつ効率的に保証します',
    homeaboutustitle2: '24時間365日カスタマーサービス',
    homeaboutusdesc2: '24時間オンラインサポート、いつでもご要望にお応えします',
    homeaboutustitle3: 'グローバルカバレッジ',
    homeaboutusdesc3: '国際的なコミュニティ、205の国と地域をカバー、11言語対応、19の国・地域コミュニティ、500万人の登録ユーザー',
    totrade: '取引を開始',
    toregister: 'デジタル通貨の旅を始めましょう',
    yingli: '本日の利益',
    kuisun: '本日の損失',
    agree: '私は既に読み、同意します',
    useragreement:'利用規約',
    account: 'アカウント',
    pwd:'パスワード',
    toregister1: 'まだ登録していません',
    loginbtn: 'ログイン',
    registerbtn: '今すぐ登録',
    tologin: 'すでにアカウントをお持ちの方、登録へ',
    allrevenue:'総収益',
    stakingcount: 'ステーキング注文',
    stakingamount: 'ステーキング金額',
    todayincome: '本日の見積もり'

    }
      
}
